module.exports = __webpack_public_path__ + "media/images/top/about-lead-dff2207d823d4ffd036e0bf0e9f3025c.svg";